import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff } from "lucide-react";

export function PasswordInput({ value, onChange, placeholder, className = "", id, required, minLength, testid, "data-testid": dataTestId }) {
  const [show, setShow] = useState(false);
  const testIdValue = testid || dataTestId;

  return (
    <div className="relative w-full">
      <Input
        id={id}
        type={show ? "text" : "password"}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        minLength={minLength}
        className={`pr-10 bg-white ${className}`}
        data-testid={testIdValue}
      />
      <button
        type="button"
        onClick={() => setShow(!show)}
        className="absolute right-2.5 top-1/2 -translate-y-1/2 text-slate-400 hover:text-primary transition-colors p-1.5 rounded-full hover:bg-slate-100 focus:outline-none z-10"
        tabIndex={-1}
        title={show ? "Hide password" : "Show password"}
      >
        {show ? <EyeOff className="w-4 h-4 text-slate-600" /> : <Eye className="w-4 h-4 text-primary" />}
      </button>
    </div>
  );
}
